import React from 'react';

export class NoteTag extends React.PureComponent {
  makeTagString = () => {
    let { category, note } = this.props.data;

    return (
      <span className={'note-tag__note'}>
        <b>{category}</b>
        {note && note.length ? ': ' + note : ''}
      </span>
    );
  };

  render() {
    let { data } = this.props;
    if (!data) return <></>;

    return (
      <span
        className={`note-tag ${this.props.editable ? 'large editable' : ''}`}
        style={{ backgroundColor: data.color }}
      >
        {this.makeTagString()}
        {!!this.props.editable && (
          <>
            {this.props.data.media_src && (
              <span
                className={'note-tag__action'}
                onClick={() => this.props.onShowImage(this.props.data.media_src)}
              >
                4
                <i className={'fas fa-camera'} />
              </span>
            )}

            <span
              className={'note-tag__action'}
              onClick={() => this.props.onRemoveNote(this.props.data.id || this.props.data)}
            >
              <i className={'fas fa-times'} />
            </span>
          </>
        )}
      </span>
    );
  }
}

export default class NoteTagList extends React.PureComponent {
  render() {
    let notes = this.props.notes || [];
    if (!notes.length && this.props.addButton)
      return (
        <>
          <span className={'grey-text'}>
            <i className={'fas fa-sticky-note'}></i>
          </span>
        </>
      );

    return (
      <div className={'note-tag-wrapper'} style={{ ...(this.props.style || {}) }}>
        {notes.map((d, i) => (
          <NoteTag {...this.props} key={d.id || `${d.category}${d.note}`} data={d} />
        ))}
      </div>
    );
  }
}
